import { IconBase, IconBaseProps } from 'react-icons';

import { IconManifest } from 'app/agriculture/icons/types';

const lightIcon: IconManifest = {
    id: 'light-icon',
    width: 128,
    height: 128,
    d: 'M64 16a5.333 5.333 0 0 1 5.333 5.333v7.758a5.333 5.333 0 0 1-10.666 0v-7.758A5.333 5.333 0 0 1 64 16ZM30.052 30.052a5.333 5.333 0 0 1 7.542 0l5.508 5.508a5.333 5.333 0 1 1-7.542 7.542l-5.508-5.508a5.333 5.333 0 0 1 0-7.542Zm67.896 0a5.333 5.333 0 0 1 0 7.542l-5.508 5.508a5.333 5.333 0 1 1-7.542-7.542l5.508-5.508a5.333 5.333 0 0 1 7.542 0ZM64 49.939c-7.766 0-14.06 6.295-14.06 14.061S56.233 78.06 64 78.06c7.766 0 14.06-6.294 14.06-14.06 0-7.766-6.294-14.06-14.06-14.06ZM39.273 64c0-13.657 11.07-24.727 24.727-24.727 13.656 0 24.727 11.07 24.727 24.727 0 13.656-11.07 24.727-24.727 24.727S39.273 77.657 39.273 64ZM16 64a5.333 5.333 0 0 1 5.333-5.333h7.758a5.333 5.333 0 0 1 0 10.666h-7.758A5.333 5.333 0 0 1 16 64Zm77.576 0a5.333 5.333 0 0 1 5.333-5.333h7.758a5.333 5.333 0 0 1 0 10.666h-7.758A5.333 5.333 0 0 1 93.576 64ZM43.102 84.898a5.333 5.333 0 0 1 0 7.542l-5.508 5.508a5.333 5.333 0 0 1-7.542-7.542l5.508-5.508a5.333 5.333 0 0 1 7.542 0Zm41.796 0a5.333 5.333 0 0 1 7.542 0l5.508 5.508a5.333 5.333 0 0 1-7.542 7.542l-5.508-5.508a5.333 5.333 0 0 1 0-7.542ZM64 93.576a5.333 5.333 0 0 1 5.333 5.333v7.758a5.333 5.333 0 0 1-10.666 0v-7.758A5.333 5.333 0 0 1 64 93.576Z',
};

export function LightIcon(props: IconBaseProps) {
    const { id, d } = lightIcon;

    return (
        <IconBase id={id} {...props} viewBox="16 16 96 96" data-testid="LightIcon">
            <path d={d} fill="currentColor" />
        </IconBase>
    );
}
